import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { AudioCard } from './AudioCard';
import { ElegantVine } from './ElegantVine';
const AUDIOS = [{
  id: '01',
  title: 'The Transfer Breath',
  description: 'Use this before every put-down',
  duration: '3:37',
  audioUrl: 'https://cdn.magicpatterns.com/uploads/kDBR9aJXheCZPh2pt52mgj/1_The_Transfer_Breath_English_music (1).mp4'
}, {
  id: '02',
  title: 'The Failed Transfer Reset',
  description: 'Use this when the transfer fails',
  duration: '4:22',
  audioUrl: 'https://cdn.magicpatterns.com/uploads/1isMvgYuJbZFgb4GEXYh8m/2_The_Failed_Transfer_Reset_English_music.mp4'
}, {
  id: '03',
  title: 'The Guilt Interrupt',
  description: 'Use this when the guilt spiral starts',
  duration: '5:19',
  audioUrl: 'https://cdn.magicpatterns.com/uploads/ojxLUxrCR6ifymL3b6J5At/3The Guilt Interrupt_English_music.mp4'
}, {
  id: '04',
  title: 'The Contact Nap Permission',
  description: 'Use this when you need permission to stay',
  duration: '5:44',
  audioUrl: 'https://cdn.magicpatterns.com/uploads/aGSoTyrhafcfKvdXDnbFvk/4The Contact Nap Permission_English_music.mp4'
}, {
  id: '05',
  title: 'The Overstimulation Exit',
  description: 'Use this when everything feels like too much',
  duration: '4:38',
  audioUrl: 'https://cdn.magicpatterns.com/uploads/wmR6TsuD7ye7sSyt9vVnsJ/5The Overstimulation Exit-English_music.mp4'
}, {
  id: '06',
  title: 'The Partner Bridge',
  description: 'Use this before a hard conversation',
  duration: '5:42',
  audioUrl: 'https://cdn.magicpatterns.com/uploads/p5k5kGHMU4yb9bTVSeuGeo/6The Partner Bridge_English_music.mp4'
}, {
  id: '07',
  title: 'The Morning Anchor',
  description: 'Use this in your first 3 minutes of the day',
  duration: '4:01',
  audioUrl: 'https://cdn.magicpatterns.com/uploads/t3wJZz2tj4Nb9a3QPui1C7/7The Morning Anchor_English_music.mp4'
}, {
  id: '08',
  title: 'The Nap Window Prep',
  description: 'Use this 5 minutes before the nap window',
  duration: '5:01',
  audioUrl: 'https://cdn.magicpatterns.com/uploads/hBcwbzjFvFkPuaNsmskvkz/8The Nap Window Prep-English_music.mp4'
}, {
  id: '09',
  title: 'The "I Can\'t Do This" Response',
  description: "Use this when you're at your limit",
  duration: '6:54',
  audioUrl: "https://cdn.magicpatterns.com/uploads/31BdncNjpQmyaurEJYNQBC/9The _I Can't Do This_ Response_English_music.mp4"
}, {
  id: '10',
  title: 'The End of Day Release',
  description: 'Use this before you sleep',
  duration: '6:53',
  audioUrl: 'https://cdn.magicpatterns.com/uploads/1paDBKnUoWAStJB1aQWZyX/10The End of Day Release-English_music.mp4'
}];
export function AudioLibrary() {
  const [playingId, setPlayingId] = useState<string | null>(null);
  const userName = sessionStorage.getItem('gemma_user_name');
  return <div className="min-h-screen bg-gemma-cream flex justify-center w-full relative overflow-hidden" data-id="element-28">
      {/* Angelic Entry Flash */}
      <motion.div className="fixed inset-0 z-[100] bg-white pointer-events-none flex items-center justify-center" initial={{
      opacity: 1
    }} animate={{
      opacity: 0
    }} transition={{
      duration: 3,
      ease: 'easeInOut'
    }} data-id="element-29">
        <div className="w-[800px] h-[800px] bg-[#D4AF37]/20 rounded-full blur-[150px]" data-id="element-30" />
      </motion.div>

      {/* Global Sanctuary Golden Edge Glows */}
      <div className="fixed inset-0 pointer-events-none z-50 shadow-[inset_0_0_120px_rgba(201,166,107,0.1)] mix-blend-overlay" data-id="element-31" />
      <motion.div className="fixed top-[-10%] left-[-10%] w-[50%] h-[40%] bg-gemma-gold/15 blur-[120px] rounded-full pointer-events-none z-0" animate={{
      opacity: [0.4, 0.7, 0.4],
      scale: [1, 1.1, 1]
    }} transition={{
      duration: 8,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-32" />
      <motion.div className="fixed bottom-[-10%] right-[-10%] w-[60%] h-[50%] bg-gemma-accent/10 blur-[140px] rounded-full pointer-events-none z-0" animate={{
      opacity: [0.3, 0.6, 0.3],
      scale: [1, 1.05, 1]
    }} transition={{
      duration: 10,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 2
    }} data-id="element-33" />

      <div className="w-full max-w-[420px] bg-gemma-cream/85 backdrop-blur-3xl min-h-screen flex flex-col relative shadow-[0_0_50px_rgba(44,42,40,0.08)] z-10 border-x border-gemma-charcoal/[0.04]" data-id="element-34">
        {/* Header Section */}
        <header className="pt-8 pb-6 px-6 text-center flex flex-col relative overflow-hidden items-center justify-center" data-id="element-35">
          {/* Richer radial glow behind header */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[400px] h-[400px] rounded-full bg-gemma-gold/[0.12] blur-[100px] pointer-events-none" data-id="element-36" />

          {/* Logo with gentle pulse - more visible and golden */}
          <div className="relative mx-auto mb-4 w-24 flex items-center justify-center" data-id="element-37">
            {/* Angelic flash specifically for the logo */}
            <motion.div className="absolute inset-0 bg-gemma-gold rounded-full blur-[20px] pointer-events-none" initial={{
            opacity: 0,
            scale: 0.5
          }} animate={{
            opacity: [0, 0.8, 0],
            scale: [0.8, 1.5, 1.2]
          }} transition={{
            duration: 2.5,
            ease: 'easeOut',
            delay: 0.2
          }} data-id="element-38" />

            {/* Diamond Sparkles Around Logo */}
            <motion.div className="absolute top-2 right-4 w-5 h-5 pointer-events-none z-20" initial={{
            opacity: 0,
            scale: 0,
            rotate: -45
          }} animate={{
            opacity: [0, 1, 0],
            scale: [0, 1.2, 0],
            rotate: 45
          }} transition={{
            duration: 2,
            ease: 'easeInOut',
            delay: 1.5
          }} data-id="element-39">
              <div className="absolute inset-0 bg-white rounded-full blur-[3px] opacity-80" data-id="element-40" />
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="absolute inset-0 w-full h-full text-white/90" data-id="element-41">
                <path d="M12 0C12 0 12 10 24 12C24 12 12 14 12 24C12 24 12 14 0 12C0 12 12 10 12 0Z" fill="currentColor" data-id="element-42" />
              </svg>
            </motion.div>

            <motion.div className="absolute bottom-6 left-2 w-4 h-4 pointer-events-none z-20" initial={{
            opacity: 0,
            scale: 0,
            rotate: -45
          }} animate={{
            opacity: [0, 0.8, 0],
            scale: [0, 1, 0],
            rotate: 45
          }} transition={{
            duration: 2,
            ease: 'easeInOut',
            delay: 3
          }} data-id="element-43">
              <div className="absolute inset-0 bg-white rounded-full blur-[2px] opacity-80" data-id="element-44" />
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="absolute inset-0 w-full h-full text-white/80" data-id="element-45">
                <path d="M12 0C12 0 12 10 24 12C24 12 12 14 12 24C12 24 12 14 0 12C0 12 12 10 12 0Z" fill="currentColor" data-id="element-46" />
              </svg>
            </motion.div>

            <motion.div className="absolute top-1/2 -right-1 w-3 h-3 pointer-events-none z-20" initial={{
            opacity: 0,
            scale: 0,
            rotate: -45
          }} animate={{
            opacity: [0, 0.9, 0],
            scale: [0, 1.1, 0],
            rotate: 45
          }} transition={{
            duration: 1.8,
            ease: 'easeInOut',
            delay: 4.5
          }} data-id="element-47">
              <div className="absolute inset-0 bg-white rounded-full blur-[2px] opacity-80" data-id="element-48" />
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="absolute inset-0 w-full h-full text-white/90" data-id="element-49">
                <path d="M12 0C12 0 12 10 24 12C24 12 12 14 12 24C12 24 12 14 0 12C0 12 12 10 12 0Z" fill="currentColor" data-id="element-50" />
              </svg>
            </motion.div>
          </div>

          {/* Ornamental divider */}
          <motion.div className="flex items-center justify-center gap-3 mb-5" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} data-id="element-51">
            <div className="h-px w-10 bg-gradient-to-r from-transparent to-gemma-accent/50" data-id="element-52" />
            <svg width="8" height="8" viewBox="0 0 24 24" fill="none" className="text-gemma-accent/55 shrink-0" data-id="element-53">
              <path d="M12 0C12 0 12 10 24 12C24 12 12 14 12 24C12 24 12 14 0 12C0 12 12 10 12 0Z" fill="currentColor" data-id="element-54" />
            </svg>
            <div className="h-px w-10 bg-gradient-to-l from-transparent to-gemma-accent/50" data-id="element-55" />
          </motion.div>

          <motion.div className="space-y-3 mb-4" initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.9,
          delay: 0.35,
          ease: [0.25, 0.46, 0.45, 0.94]
        }} data-id="element-56">
            {/* Headline */}
            <h1 className="font-serif text-gemma-charcoal leading-tight tracking-[-0.01em]" data-id="element-57">
              {userName ? <>
                  <span className="block italic font-normal text-gemma-charcoal tracking-[-0.01em] text-[40px]" data-id="element-58">
                    {userName}
                  </span>
                  <span className="block text-[18px] font-normal text-gemma-accent tracking-[0.08em] mt-1" data-id="element-59">
                    Audio Sanctuary
                  </span>
                </> : <>
                  Your Audio
                  <br data-id="element-60" />
                  <span className="italic font-normal text-gemma-accent" data-id="element-61">
                    Sanctuary
                  </span>
                </>}
            </h1>

            {/* Golden accent line */}
            <div className="h-px w-12 mx-auto bg-gradient-to-r from-gemma-accent/20 via-gemma-accent/60 to-gemma-accent/20" data-id="element-62" />

            {/* Subheadline */}
            <p className="text-gemma-charcoal/55 font-sans font-light max-w-[240px] mx-auto tracking-wide text-[9px]" data-id="element-63">
              Ten audios crafted for your
              <span className="italic text-gemma-charcoal/70" data-id="element-64"> hardest </span>
              moments.
              <br data-id="element-65" />
              <span className="font-medium text-gemma-charcoal/75 tracking-wide" data-id="element-66">
                Press play. Breathe. You deserve this.
              </span>
            </p>
          </motion.div>

          {/* Headphones recommendation — luxe pill */}
          <motion.div className="mt-2 mb-0 flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/50 backdrop-blur-sm border border-gemma-accent/[0.12] relative z-20" initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.7
        }} data-id="element-67">
            <svg width="14" height="14" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="shrink-0 opacity-50" data-id="element-68">
              <path d="M8 20V18C8 12.477 12.477 8 18 8C23.523 8 28 12.477 28 18V20" stroke="#B87333" strokeWidth="2" strokeLinecap="round" data-id="element-69" />
              <rect x="5" y="20" width="5" height="8" rx="2.5" stroke="#B87333" strokeWidth="2" fill="#B87333" fillOpacity="0.15" data-id="element-70" />
              <rect x="26" y="20" width="5" height="8" rx="2.5" stroke="#B87333" strokeWidth="2" fill="#B87333" fillOpacity="0.15" data-id="element-71" />
            </svg>
            <p className="font-sans text-gemma-charcoal/45 tracking-[0.2em] uppercase text-[7px] font-[400]" data-id="element-72">
              Best with headphones
            </p>
          </motion.div>
        </header>

        {/* Decorative leaf — emerges from behind the first card up to headphones pill */}
        <div className="relative flex justify-center -mt-10 -mb-20 z-0 pointer-events-none" data-id="element-73">
          <motion.img src="https://cdn.magicpatterns.com/uploads/1FSck8VMiR7vNvfLVrSepx/hoja.png" alt="" aria-hidden="true" className="w-[280px] h-auto opacity-60 object-contain" initial={{
          opacity: 0,
          y: 30,
          scale: 0.8
        }} animate={{
          opacity: 0.6,
          y: 0,
          scale: 1
        }} transition={{
          duration: 1.2,
          delay: 0.5,
          ease: 'easeOut'
        }} data-id="element-74" />
        </div>

        {/* Audio Cards List */}
        <main className="flex-1 px-5 pb-16 space-y-3.5 relative z-10" data-id="element-75">
          {AUDIOS.map((audio, index) => <AudioCard key={audio.id} id={audio.id} title={audio.title} description={audio.description} durationStr={audio.duration} audioUrl={audio.audioUrl} index={index} playingId={playingId} onPlay={setPlayingId} data-id="element-76" />)}
        </main>

        {/* Footer Section — Luxe */}
        <footer className="relative py-20 px-8 text-center mt-auto overflow-hidden" data-id="element-77">
          {/* Subtle golden radial glow */}
          <div className="absolute inset-0 pointer-events-none" data-id="element-78">
            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[300px] h-[200px] bg-gemma-gold/[0.08] rounded-full blur-[80px]" data-id="element-79" />
          </div>

          {/* Ornamental top divider */}
          <div className="flex items-center justify-center gap-3 mb-10" data-id="element-80">
            <div className="h-px w-16 bg-gradient-to-r from-transparent to-gemma-accent/55" data-id="element-81" />
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" className="text-gemma-accent/60 shrink-0" data-id="element-82">
              <path d="M12 0C12 0 12 10 24 12C24 12 12 14 12 24C12 24 12 14 0 12C0 12 12 10 12 0Z" fill="currentColor" data-id="element-83" />
            </svg>
            <div className="h-px w-16 bg-gradient-to-l from-transparent to-gemma-accent/55" data-id="element-84" />
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          ease: [0.25, 0.46, 0.45, 0.94]
        }} className="flex flex-col items-center gap-8 relative z-10" data-id="element-85">
            <p className="font-serif italic text-[13px] text-gemma-charcoal/60 max-w-[220px] leading-[1.8] tracking-wide" data-id="element-86">
              {userName ? `Made for you, ${userName}` : 'Made for you'}
              <br data-id="element-87" />
              <span className="text-gemma-charcoal/75" data-id="element-88">
                you are allowed to breathe now.
              </span>
            </p>

            <div className="flex flex-col items-center gap-2.5" data-id="element-89">
              <span className="font-serif text-[13px] tracking-[0.3em] uppercase text-gemma-charcoal/80" data-id="element-90">
                Gemma Mama
              </span>
              <div className="h-px w-8 bg-gemma-accent/45" data-id="element-91" />
              <a href="https://instagram.com/soygemmamama" target="_blank" rel="noopener noreferrer" className="font-sans text-[10px] tracking-[0.15em] text-gemma-charcoal/40 hover:text-gemma-accent transition-colors duration-500" data-id="element-92">
                @soygemmamama
              </a>
            </div>
          </motion.div>
        </footer>
      </div>
    </div>;
}